export const pluralize = (word: string, count: number | string): string =>
  count > 1 ? `${word}s` : word;
